import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=fcfc9254&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=fcfc9254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfc9254",
  null
  
)

export default component.exports